import { EditorContent, Editor } from '@tiptap/react';

interface TiptapEditorProps {
  editor: Editor | null;
  className?: string;
}

export function TiptapEditor({ editor, className = '' }: TiptapEditorProps) {
  if (!editor) {
    return null;
  }

  return (
    <div>
      <EditorContent editor={editor} className={className} placeholder='Start writing...'/>
    </div>
  );
}

export default TiptapEditor;